























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformFieldArrayUnion, TypeformFieldUnion } from '@/api/model/typeform/typeform-field'
import { TypeformLogicJump } from '@/api/model/typeform/typeform-logic-jump'
import draggable from 'vuedraggable'
import { cloneDeep, isEqual } from 'lodash'
import Field from '@/views/Company/Settings/Typeform/Forms/Detail/Field.vue'
import PopOut from '@/views/Company/Settings/Typeform/Forms/Detail/PopOut.vue'
import LogicJumpPopOut from '@/views/Company/Settings/Typeform/Forms/Detail/LogicJumpPopOut.vue'
import HookPopOut from '@/views/Company/Settings/Typeform/Forms/Detail/HookPopOut.vue'
import { TypeformResponseAnswerHook } from '@/api/model/typeform/typeform-response-answer-hook'

@Component({
    components: {
        TypeformField: Field,
        TypeformPopOut: PopOut,
        TypeformHookPopOut: HookPopOut,
        TypeformLogicJumpPopOut: LogicJumpPopOut,
        draggable,
    },
})
export default class Fieldset extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly hooks!: TypeformResponseAnswerHook[]
    @Prop({ required: true }) readonly fields!: TypeformFieldArrayUnion
    @Prop({ required: true }) readonly fieldsType!: string
    @Prop({ default: true }) readonly sortable!: boolean
    @Prop({ default: false }) readonly addDisabled!: boolean
    @Prop({ default: false }) readonly hooksDisabled!: boolean
    internalFields: TypeformFieldArrayUnion = []
    popOutField: TypeformFieldUnion = null
    popOutShow: boolean = false
    popOutHooks: TypeformResponseAnswerHook[] = []
    popOutHookShow: boolean = false
    logicJumpPopOutLogicJump: TypeformLogicJump = null
    logicJumpPopOutShow: boolean = false

    @Watch('fields', { deep: true, immediate: true })
    onFieldsChanged() {
        this.internalFields = cloneDeep(this.fields)
    }

    @Watch('internalFields', { deep: true })
    onInternalFieldsChanged() {
        if (isEqual(this.internalFields, this.fields)) {
            return
        }

        this.$emit('update:fields', this.internalFields)
    }

    findHooks(fieldId: string): TypeformResponseAnswerHook[] {
        return this.hooks.filter(hook => hook.fieldId === fieldId)
    }

    onAddField(): void {
        this.$emit('addField')
    }

    onEditField(field: TypeformFieldUnion): void {
        this.popOutField = field
        this.popOutShow = true
    }

    onDeleteField(field: TypeformFieldUnion): void {
        this.$emit('deleteField', field)
    }

    onMoveField(field: TypeformFieldUnion, oldIndex: number, newIndex: number): void {
        this.$emit('moveField', field, oldIndex, newIndex)
    }

    onDraggableUpdate(event) {
        this.onMoveField(
            this.internalFields[event.newIndex],
            event.oldIndex,
            event.newIndex,
        )
    }

    onPopOutSave(field: TypeformFieldUnion): void {
        this.internalFields.splice(
            this.internalFields.findIndex((internalField => internalField.ref === field.ref)),
            1,
            field,
        )
    }

    onPopOutClosed(): void {
        this.popOutField = null
        this.popOutShow = false
    }

    async onEditHooks(field: TypeformFieldUnion): Promise<void> {
        this.popOutHooks = this.findHooks(field.id)
        this.popOutField = field
        this.popOutHookShow = true
    }

    onHookPopOutSave(hooks: TypeformResponseAnswerHook[]): void {
        this.$emit('updateHooks', hooks)
    }

    onHookPopOutDelete(hooks: TypeformResponseAnswerHook[]): void {
        this.$emit('deleteHooks', hooks)
    }

    onHookPopOutClosed(): void {
        this.popOutHooks = []
        this.popOutField = null
        this.popOutHookShow = false
    }

    onEditLogicJump(field: TypeformFieldUnion): void {
        const logicJump = this.form.getOrCreateLogicForField(field)
        if (!logicJump) {
            return
        }

        this.logicJumpPopOutLogicJump = logicJump
        this.logicJumpPopOutShow = true
    }

    onLogicJumpPopOutSave(logicJump: TypeformLogicJump): void {
        this.$emit('updateLogicJump', logicJump)
    }

    onLogicJumpPopOutClosed(): void {
        this.logicJumpPopOutLogicJump = null
        this.logicJumpPopOutShow = false
    }
}
